module.exports = __webpack_public_path__ + "img/quizmayhem_banner_usarevolution.78200ccd.jpg";